import React, { Component, forwardRef, useImperativeHandle } from 'react';
import {
    BlockStack, TextField, Button, DropZone, Thumbnail, Banner,
    Spinner,
    Card,
    Text,
} from '@shopify/polaris';
import ToastFunc from '../../../../../components/ToastFunc';
import { reqInsertCreateCampaignImage, reqSaveJsonLdV2 } from '../../../../../api';
import LoadingPageForms from "./LoadingPageForms";
import Language from '../../../../../i18n/Language';
import SaveBarTop from '../../../../../components/SaveBarTop';
import { showNewMessage } from '@intercom/messenger-js-sdk';
import '../index.scss';
const t = Language

class LogoForms extends Component {

    constructor(props) {
        super(props);
        this.state = {

            // 保存按钮加载状态
            firstSaveButtonLoading: false,

            //页面动作
            loading: this.props.loading,
            loadingPage: false,
            //弹窗
            showToast: false,  //弹窗显示
            showToastText: '',  //弹窗文字
            showToastIserror: false, //弹窗是否错误

            //logo图片1
            files: '',
            fileUpload: '',
            uploadedFiles: '',
            //图片删除按钮
            imgButton: true,
            //父组件传过来的值
            logo_url: props.logo_url,
            organization_name: props.organization_name,
            youtube_url: props.social_media_data.youtube_url ? props.social_media_data.youtube_url : '',
            facebook_url: props.social_media_data.facebook_url ? props.social_media_data.facebook_url : '',
            google_url: props.social_media_data.google_url ? props.social_media_data.google_url : '',
            twitter_url: props.social_media_data.twitter_url ? props.social_media_data.twitter_url : '',
            linkedin_url: props.social_media_data.linkedin_url ? props.social_media_data.linkedin_url : '',
            instagram_url: props.social_media_data.instagram_url ? props.social_media_data.instagram_url : '',
            pinterest_url: props.social_media_data.pinterest_url ? props.social_media_data.pinterest_url : '',
            tiktok_url: props.social_media_data.tiktok_url ? props.social_media_data.tiktok_url : '',
            origin: props.originData,
            isUploadStatus: false, // 上传状态
            initBtnState: true,     // 首次禁用状态
            isShowGifBanner: '',
            isShowSaveBar: false,
            isOtherModule: props.isOtherModule,
        };
    }

    componentDidMount() {
        if (this.state.logo_url) {
            this.setUpdateImage(1, 0, this.state.logo_url);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.organization_name !== this.props.organization_name) {
            this.setState({
                organization_name: nextProps.organization_name,
                youtube_url: nextProps.social_media_data.youtube_url ? nextProps.social_media_data.youtube_url : '',
                facebook_url: nextProps.social_media_data.facebook_url ? nextProps.social_media_data.facebook_url : '',
                google_url: nextProps.social_media_data.google_url ? nextProps.social_media_data.google_url : '',
                twitter_url: nextProps.social_media_data.twitter_url ? nextProps.social_media_data.twitter_url : '',
                linkedin_url: nextProps.social_media_data.linkedin_url ? nextProps.social_media_data.linkedin_url : '',
                instagram_url: nextProps.social_media_data.instagram_url ? nextProps.social_media_data.instagram_url : '',
                pinterest_url: nextProps.social_media_data.pinterest_url ? nextProps.social_media_data.pinterest_url : '',
                tiktok_url: nextProps.social_media_data.tiktok_url ? nextProps.social_media_data.tiktok_url : '',
                origin: nextProps.originData,
            })
        }

        if (nextProps.social_media_data !== this.props.social_media_data) {
            this.setState({
                organization_name: nextProps.organization_name,
                youtube_url: nextProps.social_media_data.youtube_url ? nextProps.social_media_data.youtube_url : '',
                facebook_url: nextProps.social_media_data.facebook_url ? nextProps.social_media_data.facebook_url : '',
                google_url: nextProps.social_media_data.google_url ? nextProps.social_media_data.google_url : '',
                twitter_url: nextProps.social_media_data.twitter_url ? nextProps.social_media_data.twitter_url : '',
                linkedin_url: nextProps.social_media_data.linkedin_url ? nextProps.social_media_data.linkedin_url : '',
                instagram_url: nextProps.social_media_data.instagram_url ? nextProps.social_media_data.instagram_url : '',
                pinterest_url: nextProps.social_media_data.pinterest_url ? nextProps.social_media_data.pinterest_url : '',
                tiktok_url: nextProps.social_media_data.tiktok_url ? nextProps.social_media_data.tiktok_url : '',
                origin: nextProps.originData,
            })
        }

        if (nextProps.loading !== this.props.loading) {
            this.setState({
                loading: nextProps.loading,
                logo_url: nextProps.logo_url,
            }, () => {
                if (nextProps.logo_url) {
                    this.setUpdateImage(1, 0, nextProps.logo_url);
                }
            })
        }

        return true;
    }

    componentDidUpdate(prevProps, prevState) {
        // 只监听 count 变化
        if (prevState.isUploadStatus !== this.state.isUploadStatus && this.props.updImageUploadStatus) {
            this.props.updImageUploadStatus(this.state.isUploadStatus);
        }
    }

    handleInputChange = (value, name) => {
        //修改父组件变量
        this.props.logoInputChangeValue(name, value);
        this.setState({
            [name]: value,
            initBtnState: false,
        }, () => {
            this.checkDataChange();
        })
    }

    // 验证数据变动
    checkDataChange = () => {
        let { origin, logo_url, organization_name, youtube_url, facebook_url, google_url, twitter_url, linkedin_url, instagram_url, pinterest_url, tiktok_url } = this.state;
        let _t = origin;
        let isChange = _t.logo_url !== logo_url || _t.organization_name !== organization_name || _t.social_media_data.youtube_url !== youtube_url || _t.social_media_data.facebook_url !== facebook_url || _t.social_media_data.google_url !== google_url || _t.social_media_data.twitter_url !== twitter_url || _t.social_media_data.linkedin_url !== linkedin_url || _t.social_media_data.instagram_url !== instagram_url || _t.social_media_data.pinterest_url !== pinterest_url || _t.social_media_data.tiktok_url !== tiktok_url;
        this.toggleShopifySavebar(isChange);
    }

    //删除图片
    deleteImage = () => {
        this.setState({
            files: '',
            imgButton: true,
            logo: '',
            initBtnState: false,
        }, () => {
            this.setUpdateImage();
            this.toggleShopifySavebar(true);
        });
    }

    //上传图片
    updateImage = (acceptedFiles) => {
        if (acceptedFiles.length === 0) {
            this.setState({
                isShowGifBanner: "Only accepts .jpg, .jpeg and .png"
            })
        } else {
            const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
            if (!validImageTypes.includes(acceptedFiles[0].type)) {
                this.setState({
                    isShowGifBanner: "Only accepts .jpg, .jpeg and .png"
                })
            } else {
                this.setState({
                    files: acceptedFiles[0],
                    initBtnState: false,
                }, () => {
                    this.toggleShopifySavebar(true);
                });
            }

            this.setUpdateImage(1, acceptedFiles[0]);
        }
    };

    //设置图片
    setUpdateImage = async (type, acceptedFiles, img) => {
        this.setState({ isUploadStatus: true, })
        var fileUpload = '';
        var uploadedFiles = '';
        var logo = "";
        if (img) {
            fileUpload = !img && <DropZone.FileUpload />;
            uploadedFiles = img && (
                <div className="updImage">
                    <Thumbnail
                        size="small"
                        alt=''
                        source={img}
                    />
                </div>
            );
            this.setState({
                imgButton: false,
                fileUpload: fileUpload,
                uploadedFiles: uploadedFiles,
                isUploadStatus: false,
            });
        } else if (acceptedFiles) {
            const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
            const filesImg = acceptedFiles
            if (validImageTypes.indexOf(filesImg.type) >= 0) {
                fileUpload = !filesImg && <DropZone.FileUpload />;

                //开启FileReader
                var reader = new FileReader();
                reader.readAsDataURL(filesImg); //读取文件保存在result中
                reader.onload = (e) => {
                    var getRes = e.target.result;//读取的结果在result中
                    const params = { img: getRes, type: filesImg.type };
                    reqInsertCreateCampaignImage(params).then(response => {
                        if (response.code === '200') {
                            uploadedFiles = filesImg && (
                                <div className="updImage">
                                    <Thumbnail
                                        size="small"
                                        alt={filesImg.name}
                                        source={response.data}
                                    />
                                </div>
                            );
                            logo = response.data;
                        } else {
                            fileUpload = <DropZone.FileUpload />;
                            uploadedFiles = '';
                        }

                        this.setState({
                            imgButton: false,
                            fileUpload: fileUpload,
                            uploadedFiles: uploadedFiles,
                            logo_url: logo,
                            isUploadStatus: false,
                        });
                    })
                }
            } else {
                fileUpload = <DropZone.FileUpload />;
                uploadedFiles = ''
                this.setState({
                    fileUpload: fileUpload,
                    uploadedFiles: uploadedFiles,
                    logo_url: logo,
                    isUploadStatus: false,
                });
            }
        } else {
            fileUpload = <DropZone.FileUpload />;
            uploadedFiles = ''
            this.setState({
                fileUpload: fileUpload,
                uploadedFiles: uploadedFiles,
                logo_url: logo,
                isUploadStatus: false,
            });
        }
    }

    //更新数据
    updateStructuredData = async () => {
        const state = this.state;
        let res = '';
        this.setState({ firstSaveButtonLoading: true });
        let params = {
            action: "organization",
            organization_name: state.organization_name,
            logo_url: state.logo_url,
            social_media_data: {
                youtube_url: state.youtube_url,
                facebook_url: state.facebook_url,
                google_url: state.google_url,
                twitter_url: state.twitter_url,
                linkedin_url: state.linkedin_url,
                instagram_url: state.instagram_url,
                pinterest_url: state.pinterest_url,
                tiktok_url: state.tiktok_url,
            }
        };

        res = await reqSaveJsonLdV2(params)
        this.setState({ firstSaveButtonLoading: false });
        if (res.code === '1000') {
            this.props.upgradeModal(1, 'JSONLD', 'structured_data');
        }
        if (res.ack === 1) {
            this.setState({
                initBtnState: true,
            })
            this.toggleShopifySavebar(false);
            this.toggleToast(res.msg, false);

            if (this.state.isOtherModule) {
                this.props.updOpenJsonldAll();
            }
        } else {
            this.toggleToast(res.msg, true);
        }
    }

    //提示弹窗
    toggleToast = (showToastText, showToastIserror) => {
        this.setState({
            showToast: false
        }, () => {
            this.setState(({ showToast }) => ({
                showToast: !showToast,
                showToastText: showToastText,
                showToastIserror: showToastIserror
            }));
        });
    };

    // 监听点击上传
    uploadImageData = () => {
        let objClick = document.querySelector('.Polaris-DropZone')
        if (Boolean(objClick)) {
            objClick.click();
        }
    }

    //点击联系客服
    handleContactService = () => {
        try {
            showNewMessage()
        } catch (e) {
            this.toggleToast(t("Try again later"), true);
        }
    }

    // 设置保存bar
    toggleShopifySavebar = (state) => {
        window.savebarState = state;
        this.setState({
            isShowSaveBar: state,
        })
    }

    // 保存
    handleShopifySave = () => {
        this.updateStructuredData('Organization');
    }

    // 舍弃
    handleShopifyDiscard = () => {
        let { origin } = this.state;
        let _t = origin?.social_media_data || {};
        this.setState({
            logo_url: origin.logo_url,
            organization_name: origin.organization_name,
            youtube_url: _t.youtube_url ? _t.youtube_url : '',
            facebook_url: _t.facebook_url ? _t.facebook_url : '',
            google_url: _t.google_url ? _t.google_url : '',
            twitter_url: _t.twitter_url ? _t.twitter_url : '',
            linkedin_url: _t.linkedin_url ? _t.linkedin_url : '',
            instagram_url: _t.instagram_url ? _t.instagram_url : '',
            pinterest_url: _t.pinterest_url ? _t.pinterest_url : '',
            tiktok_url: _t.tiktok_url ? _t.tiktok_url : '',
            imgButton: !Boolean(origin.logo_url),
            isUploadStatus: false,
        }, () => {
            this.setUpdateImage(1, 0, origin.logo_url);
            this.toggleShopifySavebar(false);
            this.props.resetData();
        })
    }

    render() {
        const {
            isShowGifBanner,
            // initBtnState,
            firstSaveButtonLoading,
            isUploadStatus,
            isShowSaveBar,
            loading,
            isOtherModule,

        } = this.state;


        const platformList = [
            {
                name: 'X(Twitter)',
                icon: '/imgs/platform-icon/x.png',
            },
            {
                name: 'LinkedIn',
                icon: '/imgs/platform-icon/linkedin.png',
            },
            {
                name: 'Instagram',
                icon: '/imgs/platform-icon/ins.png',
            },
            {
                name: 'Pinterest',
                icon: '/imgs/platform-icon/pinterest.png',
            },
            {
                name: 'TikTok',
                icon: '/imgs/platform-icon/tk.png',
            },
            {
                name: 'Facebook',
                icon: '/imgs/platform-icon/fb.png',
            },
        ]

        const toastMarkup = this.state.showToast ? <ToastFunc content={this.state.showToastText} onDismiss={this.state.showToast} error={this.state.showToastIserror} /> : null;
        return this.state.loadingPage ? <LoadingPageForms /> : <div>
            <BlockStack gap={200}>
                {
                    !isOtherModule && <SaveBarTop
                        isShowSaveBar={isShowSaveBar}
                        saveLoading={firstSaveButtonLoading}
                        handleSaveAction={this.handleShopifySave}
                        handleDiscardAction={this.handleShopifyDiscard}
                    />
                }
                {
                    isShowGifBanner && <div style={{ marginBottom: '1rem' }}>
                        <Banner
                            title={isShowGifBanner}
                            tone="critical"
                            action={{
                                content: t("Contact us"),
                                onAction: this.handleContactService
                            }}
                            onDismiss={() => {
                                this.setState({ isShowGifBanner: '' })
                            }}
                        >
                        </Banner>
                    </div>
                }
                <div className='o_setting_container'>
                    <div className='o_setting_left'>
                        <Card>
                            <BlockStack gap={300}>
                                <div className='logoOrg'>
                                    <div className='o_general_upload'>
                                        <Text as="p" variant="bodyMd">{t("General Information")}</Text>
                                        {
                                            (loading || isUploadStatus) ? <div className='o_updload_loading'>
                                                <Spinner size="small" />
                                            </div> :
                                                <div className={`${!this.state.imgButton ? 'o_general_upload_dropzone' : ''}`}>
                                                    <DropZone
                                                        accept="image/*"
                                                        type="image"
                                                        onDrop={(files, acceptedFiles, rejectedFiles) => {
                                                            this.updateImage(acceptedFiles)
                                                        }}
                                                    >
                                                        {this.state.uploadedFiles}
                                                        {
                                                            !this.state.uploadedFiles && <DropZone.FileUpload actionTitle={t("Upload Logo")} actionHint={t("Accepts .jpg, and .png")} />
                                                        }
                                                    </DropZone>
                                                    {
                                                        this.state.imgButton ? null : <div className='o_general_upload_dropzone_button'>
                                                            <Button size='slim' disabled={this.state.imgButton || isUploadStatus || firstSaveButtonLoading} loading={loading || isUploadStatus} onClick={() => this.deleteImage()} outline>{t("Remove")}</Button>
                                                        </div>
                                                    }
                                                </div>
                                        }
                                    </div>
                                </div>
                                <TextField
                                    type="text"
                                    label={t("Brand name")}
                                    value={this.state.organization_name}
                                    id="organization_name"
                                    disabled={loading || firstSaveButtonLoading}
                                    onChange={this.handleInputChange}
                                />
                                <TextField
                                    type="text"
                                    label={t("Twitter URL")}
                                    value={this.state.twitter_url}
                                    id="twitter_url"
                                    disabled={loading || firstSaveButtonLoading}
                                    onChange={this.handleInputChange}
                                />
                                <TextField
                                    type="text"
                                    label={t("LinkedIn URL")}
                                    value={this.state.linkedin_url}
                                    id="linkedin_url"
                                    disabled={loading || firstSaveButtonLoading}
                                    onChange={this.handleInputChange}
                                />
                                <TextField
                                    type="text"
                                    label={t("Instagram URL")}
                                    value={this.state.instagram_url}
                                    id="instagram_url"
                                    disabled={loading || firstSaveButtonLoading}
                                    onChange={this.handleInputChange}
                                />
                                <TextField
                                    type="text"
                                    label={t("Pinterest URL")}
                                    value={this.state.pinterest_url}
                                    id="pinterest_url"
                                    disabled={loading || firstSaveButtonLoading}
                                    onChange={this.handleInputChange}
                                />
                                <TextField
                                    type="text"
                                    label={t("TikTok URL")}
                                    value={this.state.tiktok_url}
                                    id="tiktok_url"
                                    disabled={loading || firstSaveButtonLoading}
                                    onChange={this.handleInputChange}
                                />
                                <TextField
                                    type="text"
                                    label={t("Facebook URL")}
                                    value={this.state.facebook_url}
                                    id="facebook_url"
                                    disabled={loading || firstSaveButtonLoading}
                                    onChange={this.handleInputChange}
                                />
                                {/* <TextField
                                    type="text"
                                    label={t("YouTube URL")}
                                    value={this.state.youtube_url}
                                    id="youtube_url"
                                    disabled={loading}
                                    onChange={this.handleInputChange}
                                /> */}
                                {/* <TextField
                                    type="text"
                                    label={t("Google+ URL")}
                                    value={this.state.google_url}
                                    id="google_url"
                                    disabled={loading}
                                    onChange={this.handleInputChange}
                                /> */}
                            </BlockStack>
                        </Card>
                    </div>
                    <div className='o_preview_right' style={{ display: isOtherModule ? 'none' : 'block' }}>
                        <Card padding={0}>
                            <div className='org_preview_container'>
                                <div className='org_preview_header_title'>
                                    <Text as="h2" variant="headingLg">{t("Preview")}</Text>
                                </div>
                                <div className='org_preview_content'>
                                    {/* Logo and Brand */}
                                    <div className='org_preview_header'>
                                        <div className='org_preview_logo'>
                                            {this.state.logo_url ? (
                                                <img src={this.state.logo_url} alt="logo" />
                                            ) : (
                                                <div className='org_preview_logo_placeholder'>
                                                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 8C0 3.58172 3.58172 0 8 0H52C56.4183 0 60 3.58172 60 8V52C60 56.4183 56.4183 60 52 60H8C3.58172 60 0 56.4183 0 52V8Z" fill="#EBEBEB" />
                                                        <path d="M44.1572 16.4725C44.1265 16.2503 43.9316 16.127 43.7698 16.1136C43.6092 16.1002 40.4632 16.0526 40.4632 16.0526C40.4632 16.0526 37.8321 13.5086 37.5722 13.2498C37.3123 12.991 36.8047 13.0692 36.6073 13.1278C36.6048 13.129 36.1132 13.2803 35.2856 13.5355C35.1471 13.0887 34.9436 12.5394 34.653 11.9876C33.7163 10.2078 32.3444 9.26665 30.6868 9.26421C30.6843 9.26421 30.6831 9.26421 30.6807 9.26421C30.5654 9.26421 30.4514 9.2752 30.3362 9.28496C30.2871 9.22637 30.2381 9.169 30.1866 9.11284C29.4644 8.3438 28.5388 7.96904 27.4292 8.002C25.2886 8.06303 23.1565 9.60235 21.4278 12.3367C20.2116 14.2606 19.2859 16.6776 19.0236 18.5489C16.5654 19.307 14.8465 19.8368 14.8085 19.849C13.5677 20.2372 13.5285 20.275 13.3667 21.4396C13.2465 22.3197 10 47.3149 10 47.3149L37.2068 52L48.9988 49.0813C48.9988 49.0813 44.1878 16.6947 44.1572 16.4725ZM33.9235 13.9554C33.297 14.1483 32.5847 14.368 31.8123 14.606C31.7964 13.5269 31.6676 12.0255 31.1625 10.7278C32.787 11.0342 33.5864 12.8641 33.9235 13.9554ZM30.3889 15.0455C28.963 15.4849 27.4072 15.9647 25.8464 16.4456C26.2854 14.772 27.1178 13.1058 28.1403 12.0132C28.5204 11.6068 29.0525 11.1539 29.6827 10.8951C30.2749 12.1256 30.4036 13.8675 30.3889 15.0455ZM27.4722 9.42046C27.9748 9.40948 28.3978 9.51934 28.7595 9.75616C28.1808 10.0552 27.6217 10.4849 27.097 11.0452C25.7373 12.4979 24.6952 14.7525 24.2796 16.9278C22.9837 17.327 21.7159 17.7188 20.5488 18.0777C21.2856 14.6536 24.168 9.51568 27.4722 9.42046Z" fill="#95BF47" />
                                                        <path d="M43.771 16.115C43.6104 16.1016 40.4644 16.054 40.4644 16.054C40.4644 16.054 37.8333 13.51 37.5734 13.2512C37.4765 13.1548 37.3454 13.1047 37.208 13.084L37.2093 51.999L49 49.0815C49 49.0815 44.1891 16.6961 44.1584 16.4739C44.1277 16.2517 43.9316 16.1284 43.771 16.115Z" fill="#5E8E3E" />
                                                        <path d="M30.6721 22.1516L29.3026 27.2529C29.3026 27.2529 27.775 26.5608 25.9641 26.6743C23.3085 26.8415 23.2803 28.509 23.3073 28.9277C23.452 31.2092 29.4804 31.7073 29.8187 37.0515C30.0848 41.2556 27.5788 44.1316 23.9681 44.3587C19.6341 44.6309 17.2483 42.0857 17.2483 42.0857L18.1666 38.1966C18.1666 38.1966 20.5683 40.0008 22.4908 39.8799C23.7462 39.8006 24.1949 38.7837 24.1496 38.0647C23.9608 35.0886 19.0518 35.2644 18.7416 30.3743C18.4804 26.2592 21.1949 22.0893 27.184 21.7133C29.4914 21.5656 30.6721 22.1516 30.6721 22.1516Z" fill="white" />
                                                    </svg>
                                                </div>
                                            )}
                                        </div>
                                        <div className='org_preview_brand'>
                                            <Text as="h2" variant="headingLg">{this.state.organization_name || t("My Store")}</Text>
                                            <div className='org_preview_brand_label'>
                                                ({t("Brand name")})
                                            </div>
                                        </div>
                                    </div>

                                    <div className='org_preview_divider'></div>

                                    {/* URL */}
                                    <div className='org_preview_url'>
                                        <div className='org_preview_url_icon'>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="20" height="20" rx="10" fill="#E2EEFF" />
                                                <path d="M14.13 13.773C13.948 13.213 13.423 12.8 12.8 12.8H12.1V10.7C12.1 10.5143 12.0262 10.3363 11.895 10.205C11.7637 10.0738 11.5857 10 11.4 10H7.2V8.6H8.6C8.78565 8.6 8.9637 8.52625 9.09497 8.39497C9.22625 8.2637 9.3 8.08565 9.3 7.9V6.5H10.7C11.0713 6.5 11.4274 6.3525 11.6899 6.08995C11.9525 5.8274 12.1 5.4713 12.1 5.1V4.813C12.9375 5.15066 13.6808 5.68623 14.2661 6.37388C14.8514 7.06154 15.2614 7.88078 15.4609 8.7615C15.6605 9.64221 15.6436 10.5582 15.4118 11.4309C15.18 12.3037 14.7402 13.1073 14.13 13.773ZM9.3 15.551C6.535 15.208 4.4 12.856 4.4 10C4.4 9.566 4.456 9.146 4.547 8.747L7.9 12.1V12.8C7.9 13.1713 8.0475 13.5274 8.31005 13.7899C8.5726 14.0525 8.9287 14.2 9.3 14.2M10 3C9.08075 3 8.17049 3.18106 7.32122 3.53284C6.47194 3.88463 5.70026 4.40024 5.05025 5.05025C3.7375 6.36301 3 8.14348 3 10C3 11.8565 3.7375 13.637 5.05025 14.9497C5.70026 15.5998 6.47194 16.1154 7.32122 16.4672C8.17049 16.8189 9.08075 17 10 17C11.8565 17 13.637 16.2625 14.9497 14.9497C16.2625 13.637 17 11.8565 17 10C17 9.08075 16.8189 8.17049 16.4672 7.32122C16.1154 6.47194 15.5998 5.70026 14.9497 5.05025C14.2997 4.40024 13.5281 3.88463 12.6788 3.53284C11.8295 3.18106 10.9193 3 10 3Z" fill="#0060F0" />
                                            </svg>
                                        </div>
                                        <span>{this.props.origin || 'https://yourstore.myshopify.com'}</span>
                                    </div>

                                    {/* Placeholder bars */}
                                    <div className='org_preview_skeleton'>
                                        <div className='org_preview_skeleton_bar' style={{ width: '100%' }}></div>
                                        <div className='org_preview_skeleton_bar' style={{ width: '100%' }}></div>
                                        <div className='org_preview_skeleton_bar' style={{ width: '60%' }}></div>
                                    </div>

                                    <div className='org_preview_divider'></div>

                                    {/* Social Profiles */}
                                    <div className='org_preview_profiles'>
                                        <div className='org_preview_profiles_title'>{t("Profiles")}</div>
                                        <div className='org_preview_profiles_grid'>
                                            {
                                                platformList.map((item, index) => (
                                                    <div className={`org_preview_profile_item ${item.name}`} key={`${item.name}-${index}`}>
                                                        <div className='org_preview_profile_icon'>
                                                            <img src={item.icon} alt="" />
                                                        </div>
                                                        <span>{item.name}</span>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
                {/* {
                    !isShopify && <div>
                        <Button disabled={initBtnState} variant='primary' loading={firstSaveButtonLoading} onClick={() => this.updateStructuredData('Organization')}>{t("Save")}</Button>
                    </div>
                } */}
            </BlockStack>
            {toastMarkup}
        </div>;
    }
}

export default LogoForms;